<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.25 9V8.5H3.75H2.5C1.9488 8.5 1.5 8.0512 1.5 7.5V1.5C1.5 0.948799 1.9488 0.5 2.5 0.5H9.5C10.0512 0.5 10.5 0.948799 10.5 1.5V7.5C10.5 8.0512 10.0512 8.5 9.5 8.5H7.5H7.3095L7.16729 8.62676L4.25 11.2273L4.25 9Z" stroke="currentColor"/>
</svg>
